<app-form-control
	[customLabel]="customLabel"
	[helpText]="helpText"
	[inline]="inline"
	[label]="label"
>
	<ng-container *ngIf="customLabel" label><ng-content></ng-content></ng-container>
	<input 
		class="form-control"
		[ngClass]="{'form-control-sm': small}"
		[disabled]="disabled"
		[(ngModel)]="inputValue" 
		[attr.autofocus]="autofocus ? 'true' : null"
		(input)="updateFormInputValue()"
		(change)="updateFormInputValue()" 
		(keyup.enter)="keyupEnterTrigger()"
		[name]="inputName"
		[ngModelOptions]="{ standalone: true }"
		[placeholder]="placeholder"
		[type]="type"/>
</app-form-control>
